import { render, staticRenderFns } from "./Declarations.vue?vue&type=template&id=2d827558"
import script from "./Declarations.vue?vue&type=script&lang=js"
export * from "./Declarations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports